import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import qs from 'qs';
import { stringToBoolean } from 'deep-cuts';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { LinkContainer } from 'react-router-bootstrap';
import { AuthContext } from '../components/Auth';

const getQuery = () => qs.parse(window.location.search.replace(/^\?/gi, '')) || {};

const isAutoLogin = () => {
  const query = getQuery();
  return stringToBoolean(query.autoLogin);
};

const isTokenLogin = () => {
  const query = getQuery();
  return query.token && query.email && query.dealerId ? query : {};
};

export function Home(props) {
  const { user, isLoading, router } = props;
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const { token, email, dealerId } = isTokenLogin();
    // NOTE - Unfortunately, all three are required for an application token login.
    if (!!token && !!email && !!dealerId) {
      login(token, email, dealerId);
    } else if (isAutoLogin() && !user) {
      login();
    }
  }, []);

  if (isLoading) {
    return <ProgressBar now={100} active={true} />;
  }

  if (!user) {
    return (
      <div>
        <Helmet title="Payment Gateway" />

        <Grid>
          <Row>
            <Col md={6} xs={12} mdOffset={3}>
              <Button onClick={login} bsStyle="primary" bsSize="large" block>
                Login
              </Button>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  const prcoAdmin = _.get(user, 'dealerRel.prcoAdmin');

  if (!prcoAdmin) router.push('/invoices');

  return (
    <div>
      <Helmet title="Home" />

      <Grid>
        <Row>
          <Col md={8} xs={12} mdOffset={2}>
            <LinkContainer to="/invoices">
              <Button
                bsStyle="primary"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Invoices
              </Button>
            </LinkContainer>
          </Col>
        </Row>
        {prcoAdmin && (
          <Row>
            <Col md={8} xs={12} mdOffset={2}>
              <LinkContainer to="/admin/cache">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  block
                  className="home-container-link-container"
                >
                  ADMIN: Cache
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        )}
      </Grid>
    </div>
  );
}

export default connect((state) => ({
  user: state.auth.user,
  isLoading: state.auth.isLoading,
}))(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js